import { Link, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import ArrowBackground from 'v2/assets/vector/ArrowBackground';

export interface Props {
  paperWidth: string;
  paperPadding: string;
  windowId: string;
  showFooter?: boolean;
}

const AuthLayout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  paperWidth,
  paperPadding,
  windowId,
  showFooter = false
}) => {
  return (
    <Stack width="100vw" height="100vh" alignItems="center" justifyContent="center">
      <ArrowBackground
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          height: {
            xs: '100vh',
            lg: 'auto'
          },
          width: {
            xs: 'auto',
            lg: '30vw'
          },
          zIndex: -1
        }}
      />
      <Paper
        elevation={3}
        data-testid={windowId}
        id={windowId}
        sx={{ padding: paperPadding, width: paperWidth, borderRadius: '10px' }}
      >
        {children}
      </Paper>
      {showFooter && (
        <Stack style={{ position: 'absolute', bottom: 16, left: 24 }} gap={1.5}>
          <Typography
            variant="caption"
            color="textSecondary"
            alignSelf="center"
            justifyContent="center"
            textAlign="center"
          >
            <Link href="https://tkhsecurity.com/terms-conditions/" target="_blank" color="inherit" underline="none">
              Terms of Service
            </Link>
          </Typography>
          <Typography
            variant="caption"
            color="textSecondary"
            alignSelf="center"
            justifyContent="center"
            textAlign="center"
          >
            <Link
              href="https://tkhsecurity.com/atlas-access-privacy-policy/"
              target="_blank"
              color="inherit"
              underline="none"
            >
              Privacy
            </Link>
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default AuthLayout;
